import { render, staticRenderFns } from "./beian.vue?vue&type=template&id=07cf25be&scoped=true"
import script from "./beian.vue?vue&type=script&lang=js"
export * from "./beian.vue?vue&type=script&lang=js"
import style0 from "./beian.vue?vue&type=style&index=0&id=07cf25be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cf25be",
  null
  
)

export default component.exports